import { useState } from 'react';
import FFMProduits from './FFMProduits';
import FFMPilotes from './FFMPilotes';
import FFMProfils from './FFMProfils';
import FFMOperateurs from './FFMOperateurs';
import FFMCommandes from './FFMCommandes';

const SOUS_ONGLETS = [
  { id: 'commandes',  label: 'Commandes' },
  { id: 'pilotes',    label: 'Pilotes' },
  { id: 'produits',   label: 'Produits' },
  { id: 'operateurs', label: 'Opérateurs' },
  { id: 'profils',    label: 'Profils' },
];

function FFMModule() {
  const [ongletActif, setOngletActif] = useState('commandes');

  const renderContenu = () => {
    switch (ongletActif) {
      case 'commandes':  return <FFMCommandes />;
      case 'pilotes':    return <FFMPilotes />;
      case 'produits':   return <FFMProduits />;
      case 'operateurs': return <FFMOperateurs />;
      case 'profils':    return <FFMProfils />;
      default:           return null;
    }
  };

  return (
    <div>
      {/* En-tête FFM */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        marginBottom: '24px'
      }}>
        <div style={{
          backgroundColor: '#003189',
          borderRadius: '12px',
          padding: '10px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <span style={{
            color: '#ffffff',
            fontWeight: '700',
            fontSize: '18px',
            letterSpacing: '1px'
          }}>
            MODULE FFM
          </span>
        </div>
        <span style={{ color: '#6c757d', fontSize: '14px' }}>
          Fédération Française de Motocyclisme — Gestion des commandes maillots
        </span>
      </div>

      {/* Barre de sous-onglets */}
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '6px',
        display: 'inline-flex',
        gap: '4px',
        marginBottom: '24px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        border: '1px solid #e9ecef'
      }}>
        {SOUS_ONGLETS.map(onglet => (
          <button
            key={onglet.id}
            onClick={() => setOngletActif(onglet.id)}
            style={{
              padding: '8px 20px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: ongletActif === onglet.id ? '600' : '500',
              backgroundColor: ongletActif === onglet.id ? '#003189' : 'transparent',
              color: ongletActif === onglet.id ? '#ffffff' : '#6c757d',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              if (ongletActif !== onglet.id) {
                e.currentTarget.style.backgroundColor = '#f0f4ff';
                e.currentTarget.style.color = '#003189';
              }
            }}
            onMouseLeave={(e) => {
              if (ongletActif !== onglet.id) {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.color = '#6c757d';
              }
            }}
          >
            {onglet.label}
          </button>
        ))}
      </div>

      {/* Contenu du sous-onglet actif */}
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        border: '1px solid #e9ecef',
        minHeight: '400px'
      }}>
        {renderContenu()}
      </div>
    </div>
  );
}

export default FFMModule;
